import { Input } from '../../../../components/ui/input/SimpleInput';
import React, { useState } from 'react';
import ButtonV2 from '../../../../components/ui/button/v2';
import { CircleAlert } from 'lucide-react';

interface CreateEmployeeProps {
    isOpen: boolean;
    isSaving?: boolean;
    onClose: () => void;
    onSave: (employee: string) => void;
}

const CreateEmployeeModal: React.FC<CreateEmployeeProps> = ({ isOpen, isSaving, onClose, onSave }) => {
    const [employee, setEmployee] = useState<string>('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setEmployee(value);
    };

    const handleSave = () => {
        onSave(employee);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto">
                <div className="space-y-4 p-6">
                    <div className="flex justify-between items-center pb-0">
                        <h2 className="text-xl font-semibold">Add Employee Details</h2>
                        <button
                            disabled={isSaving}
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 focus:outline-none"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-foreground mb-1">Employee ID</label>
                        <Input
                            type="text"
                            name="name"
                            placeholder='Enter employee ID'
                            value={employee}
                            className='px-3'
                            onChange={handleInputChange}
                            disabled={isSaving}
                        />
                    </div>
                    {employee &&
                        <div className='flex items-center p-2 bg-gray-100 gap-2 rounded-md'>
                            <div>
                                <CircleAlert className='text-gray-600 w-4 h-4'/>
                            </div>
                            <div className='text-xs text-gray-600'>
                                The Canso AI agent will change the information in the root cause analysis. Click {"‘"}Save Changes{"’"} to proceed
                            </div>
                        </div>
                    }
                </div>
                <div className="px-6 pb-6 flex gap-4 w-full">
                    <ButtonV2 disabled={isSaving} className='w-full' variant={"secondary"} onClick={onClose}>Cancel</ButtonV2>
                    <ButtonV2 disabled={!employee || isSaving} className='w-full' variant={"primary"} onClick={handleSave}>
                        {isSaving ? "Saving..." : "Save Changes"}
                    </ButtonV2>
                </div>
            </div>
        </div>
    );
};

export default CreateEmployeeModal;